"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ReferalBonusCard = _interopRequireDefault(require("./ReferalBonusCard"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _ReferalBonusCard.default;
exports.default = _default;